<template>
  <div>
    <span :class="{ 'select': noLimit }" @click="chooseItem()">
      不限
      <img v-if="noLimit" src="../../../assets/multiple_select.png">
    </span>
    <span
      v-for="(el, j) in list"
      :key="j"
      :class="{'select': curSelect(el)}"
      @click="chooseItem(el)">
      {{el.label}}
      <img v-if="curSelect(el)" src="../../../assets/multiple_select.png">
      </img>
    </span>
  </div>
</template>

<script>
export default {
  name: "MultiChoose",
  props: ['list', 'selectType', 'value'],
  data() {
    return {
      result: []
    }
  },
  computed: {
    noLimit() {
      return this.result.length === 0 || this.result.length === this.list.length
    },
    curSelect() {
      return el => {
        if (!this.result.length) return false
        return this.result.indexOf(el.value) > -1
      }
    }
  },
  watch: {
    result(v) {
      this.$emit('input', v)
    },
    value(v) {
      this.result = v
    }
  },
  methods: {
    chooseItem(el) { // 点击切换选中状态
      let selectType = this.selectType
      if (el) {
        let idx = this.result.indexOf(el.value)
        if (idx > -1) this.result.splice(idx, 1)
        else {
          if (selectType && selectType === '1') this.result = [el.value]
          this.result.push(el.value)
        }
      } else {
        this.result = []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
span {
  cursor: pointer;
  position: relative;
  display: inline-block;
  margin: 0 5px 5px 0;
  width: 60px;
  height: 30px;
  line-height: 30px;
  border: 1px solid #e9e9e9;
  text-align: center;
  &.select {
    border: 1px solid #282729;
  }
  img {
    position: absolute;
    top: 0;
    right: 0;
  }
}
</style>
